const productSettings = {
  pageTitle: "Lappa settings",
  backToSettings: "Settings",
  pageHelmetTitle: "Billing history",
  pageTitles: {
    applications: "Applications",
    billings: "Billings",
    plansAndUsage: "Plans & Consumption",
    payments: "Payments",
    sandbox: "Sandbox",
  },
  customerBillingNote:
    "Only your business billing data is shown here (not customer documents).",
  billingDecimalSeparatorHint:
    "Use a dot (.) as the decimal separator, for example 1250.50.",
  mainTabs: {
    applications: "Applications",
    billingHistory: "Billing history",
    plansAndUsage: "Plans & Consumption",
    payments: "Payments",
    sandbox: "Sandbox",
  },
  sandbox: {
    cancel: "Cancel",
    navigation: {
      switchTo: "Switch to sandbox",
      currentSandbox: "Sandbox active",
      switchBack: "Switch back to live company",
      active: "Active sandbox",
      open: "Switch to this sandbox",
      empty: "No sandbox has been created yet.",
      create: "Create sandbox",
      manage: "Manage sandboxes",
      singleLimit: "Only one sandbox can be created for a company.",
    },
    access: {
      title: "This feature is not available in Sandbox",
      disabledDescription:
        "Switch back to your live company to access this feature.",
      noPermission:
        "You don't have permission to use this feature in Sandbox.",
      disabledHint: "Not available in Sandbox",
    },
    create: {
      configurationTitle: "Starting configuration",
      configurationDescription: "Choose what to include in your new sandbox.",
      copyAccount: "Copy account",
      copyAccountDescription:
        "Settings and capabilities will be modeled after your live account.",
      newSandbox: "Create new sandbox",
      newSandboxDescription: "Nothing will be copied from your live account.",
      next: "Next",
      nameTitle: "Name sandbox",
      nameDescription:
        "We generated a name for you, but feel free to change it now or later.",
      nameLabel: "Sandbox name",
      nameRequired: "Enter a sandbox name.",
      nameTooLong: "Sandbox name must be 80 characters or fewer.",
      regenerate: "Regenerate",
      back: "Back",
      submit: "Create sandbox",
    },
    manage: {
      title: "Manage sandboxes",
      description:
        "Create an isolated environment for testing without changing your live company data.",
      emptyTitle: "No sandbox yet",
      emptyDescription:
        "Create a sandbox to safely test settings and workflows.",
      sandboxDescription: "Isolated from your live company data",
      delete: "Delete sandbox",
      deleteTitle: "Delete sandbox",
      deleteDescription:
        "This sandbox and all of its data will be permanently deleted. This action cannot be undone.",
      deleteActiveHint:
        "Switch back to your live company before deleting this sandbox.",
      created: "Sandbox created successfully.",
      deleted: "Sandbox deleted successfully.",
      retry: "Try again",
    },
    errors: {
      accessDeniedSwitchedBack: "This sandbox does not have access to the current app. Switched back to the live company.",
    },
  },
  plansAndUsage: {
    innerTabs: {
      overview: "Overview",
      usageAndLimits: "Consumption",
      includedInPlan: "Included in plan",
    },
    productFilters: {
      ariaLabel: "Product filter",
      ltax: "L'Tax",
      linvoice: "L'Invoice",
      lepr: "L'EPR",
      lauthorize: "L'Authorize",
      // Legacy key (British spelling) — keep for old sessionStorage / bookmarks
      lauthorise: "L'Authorize",
    },
    emptyProduct: "No active subscription for this product.",
    emptyProductHint: "Choose a plan to start using this product.",
    loading: "Loading plans…",
    subscriptionDrawer: {
      plan: "Plan",
      includedFeatures: "Included features",
      addons: "Add-ons",
      limits: "Limits",
      billing: "Billing",
      billingCycle: "Billing cycle",
      price: "Price",
      changePlan: "Change plan",
    },
    usagePlaceholder: "Consumption — coming soon.",
    usage: {
      periodSwitch: "Usage period",
      monthly: "Monthly",
      yearly: "Yearly",
      coreLimits: "Core limits",
      addonUsage: "Add-on usage",
      creditsTitle: "Credits",
      creditsSubtitle: "Shared across this project",
      remaining: "remaining",
      remainingValue: "{{value}} remaining",
      available: "available",
      used: "used",
      availableUsed: "{{available}} available • {{used}} used",
      percentUsed: "{{percent}}% used",
      footerResetDefault: "Consumption for current subscription period",
      metricSummary: "{{label}} — {{used}} of {{limit}} used ({{percent}}%)",
      daysToRenewal: "{{count}} days to renewal",
      manageSubscription: "Manage subscription",
      noMetrics: "No usage metrics",
      fallbackMetric: "Usage",
    },
    overview: {
      subscriptionTitle: "Subscription",
      creditsTitle: "Credits",
      addonsTitle: "Add-ons",
      planDetailsTitle: "Plan details",
      activeBadge: "Active",
      inactiveBadge: "Inactive",
      nextBillingDate: "Next billing date",
      billingCycle: "Billing cycle",
      billingCycleYearly: "Yearly",
      billingCycleMonthly: "Monthly",
      perYear: "/ year",
      perMonth: "/ month",
      perMonthShort: "/mo",
      creditSingular: "credit",
      creditPlural: "credits",
      manageCredits: "Manage credits",
      subscriptionsTitle: "Subscriptions",
      primarySubscription: "Primary subscription",
      otherSubscriptions: "Other subscriptions",
      nextBillingShort: "Next billing",
      billingMetaTotal: "Total",
      billingMetaNextBilling: "Next billing",
      creditsProjectLevel: "Shared across this project",
      summaryProjectLevel: "Project-level totals",
      viewDetails: "View details",
      manageSubscription: "Manage subscription",
      changeSubscription: "Change subscription",
      upgradePlan: "Upgrade plan",
      choosePlan: "Choose plan",
      buyAddons: "Buy addons",
      cancelSubscription: "Cancel subscription",
      canceledStatus: "Canceled",
      planLabel: "Plan",
      statusLabel: "Status",
      priceLabel: "Price",
      createdLabel: "Created",
      includedCountries: "Included countries",
      includedUsers: "Included users",
      vatReturns: "VAT returns",
      statesIncluded: "States included",
      registrationsIncluded: "Registrations",
      autoFiling: "Auto filing",
      includedFeaturesTitle: "Included features",
      subscriptionDetailsTitle: "Subscription details",
      noAddons: "No add-ons on this subscription.",
      noAddonsConnected: "No add-ons",
      oneAddonConnected: "1 add-on connected",
      addonsConnected: "{{count}} add-ons connected",
    addonsColName: "",
    addonsColLimits: "Limits",
    addonsColPeriod: "Period",
    addonsColQuantity: "Quantity",
    addonsColPrice: "Price",
      summaryTitle: "Billing summary",
      monthlyTotal: "Monthly total",
      planCost: "Plan cost",
      addons: "Add-ons",
      addonsTotal: "Add-ons total",
      total: "Total",
      includedCheck: "Included",
      perYearShort: "/yr",
      renewsOn: "Renews {{date}}",
      planNameLabel: "{{name}} plan",
    },
    planDetails: {
      transactionValuePerMonth: "Transaction value / mo",
      transactionsPerMonth: "Transactions / mo",
      thresholdCalculation: "Threshold calculation",
      integrations: "Integrations",
      salesTaxCalculation: "Sales tax calculation",
      countries: "Countries",
      states: "States",
      weight: "Weight",
      numberOfUsers: "Number of users",
      jurisdictions: "Jurisdictions",
      subscriptionPackCredit: "Subscription (1 pack credit)",
      packaging: "Packaging",
      oneReportAutoSubmit: "One report auto-submit",
      reminders: "Reminders",
      sendEinvoicesPerYear: "Send e-invoices per year",
      receiveEinvoicesPerYear: "Receive e-invoices per year",
      sendingEinvoicesPerYear: "Send einvoices per year",
      receivingEinvoicesPerYear: "Receiving einvoices per year",
      receive: "Receive",
      riskLevel: "Risk level",
      digitalLabels: "Digital labels",
      apiAccess: "API access",
      numberOfTransactionsPerMonth: "Number of transactions per month",
      totalValueOfTransactionsPerMonth: "Total value of transactions per month",
      consultationsSupport: "Consultations support",
      esListOfSales: "ES list of sales",
      distantSalesReturns: "Distant sales returns",
      digitalServicesTaxReturns: "Digital services tax returns",
      numberOfMerchants: "Number of merchants",
      numberOfTransactions: "Number of transactions",
      weightUnder: "under {{value}} t / year",
    },
    includedPlaceholder: "Included in plan — coming soon.",
  },
  tabs: {
    proforma: "Proforma invoice",
    taxInvoice: "Tax Invoice",
    creditNote: "Credit Note",
    payments: "Payments",
    requestFunds: "Request funds",
    intermediaryPayments: "Intermediary payments",
    creditsSummary: "Credits summary",
  },
  intermediaryPayments: {
    toolbar: {
      create: "Add intermediary payment",
    },
    table: {
      source: "Source",
      fundRequest: "Request Funds",
      recipient: "Recipient",
      amount: "Amount",
      approval: "Approval",
      execution: "Execution",
      deadline: "Deadline",
      executor: "Executor",
      reference: "Payment ref.",
    },
    filters: {
      approvalLabel: "Approval",
      executionLabel: "Execution",
      executorLabel: "Executor",
      overdueLabel: "Deadline",
      approvalAll: "All approvals",
      executionAll: "All execution",
      executorAll: "All executors",
      unassigned: "Unassigned",
      notOverdue: "Not overdue",
    },
    approvalStatus: {
      draft: "Draft",
      pending: "Awaiting approval",
      approved: "Approved",
      returned: "Returned",
      rejected: "Rejected",
      cancelled: "Cancelled",
      pending_approval: "Pending approval",
      returned_for_revision: "Returned for revision",
    },
    executionStatus: {
      not_started: "Not started",
      ready: "Ready to pay",
      in_progress: "With executor",
      executed: "Paid",
      failed: "Payment failed",
      unknown: "Outcome unknown",
      returned: "Returned by executor",
      cancelled: "Cancelled",
      closed: "Closed",
      outcome_unknown: "Outcome unknown",
      payment_error: "Payment error",
      payment_returned: "Payment returned",
      transferred: "Transferred",
    },
    empty: {
      title: "No intermediary payments",
      description:
        "When managers create payments against fund requests, they will appear here for approval and execution.",
      filteredTitle: "No matching intermediary payments",
      filteredDescription:
        "No intermediary payments match the selected filters. Try adjusting your filters.",
    },
    rowActions: {
      returnForRevision: "Return for revision",
    },
    lifecycle: {
      submitSuccess: "Intermediary payment submitted for approval.",
      approveSuccess: "Intermediary payment approved.",
      returnSuccess: "Intermediary payment returned for revision.",
      rejectSuccess: "Intermediary payment rejected.",
      takeSuccess: "Intermediary payment taken for execution.",
      executeSuccess: "Execution result recorded.",
      proofUploadSuccess: "Payment proof uploaded.",
      creditCheckSuccess: "Recipient credit check completed.",
      closeSuccess: "Intermediary payment closed.",
      deleteSuccess: "Intermediary payment deleted.",
      cancelSuccess: "Intermediary payment cancelled.",
      executorReturnSuccess: "Payment returned to the execution queue.",
      executeAttachmentSuccess: "Execution file uploaded.",
      paymentExecutedSuccess: "Payment marked as executed.",
      proofReplaceSuccess: "Payment proof replaced.",
      resolveOutcomeSuccess: "Outcome resolved.",
    },
    proof: {
      heading: "Payment proof",
      hint: "Upload proof of payment for this transfer.",
      fileLabel: "Proof file",
      submit: "Upload proof",
      uploading: "Uploading…",
      fileRequired: "Select a file to upload.",
      modalTitle: "Upload payment proof",
      modalUpload: "Upload",
      modalCancel: "Cancel",
      replaceConfirmBody: "The existing proof file will be replaced. Upload a new file after confirming.",
      replaceConfirmContinue: "Choose file",
      replaceConfirmTitle: "Replace payment proof?",
      replaceModalTitle: "Replace payment proof",
      replaceModalUpload: "Replace",
    },
    modal: {
      approveTitle: "Approve payment?",
      approveBody: "Approve this payment for execution.",
      approveConfirm: "Approve",
      returnApprovalTitle: "Return for revision?",
      returnApprovalBody:
        "Explain what needs to change before this payment can be approved.",
      returnConfirm: "Return",
      rejectTitle: "Reject payment?",
      rejectBody: "The payment will not be executed. Add a short reason for the team.",
      rejectConfirm: "Reject",
      commentLabel: "Comment",
      commentRequired: "Enter a comment.",
      submitTitle: "Submit for approval?",
      submitBody:
        "Send this payment to the approval queue. You will not be able to edit it until it is returned.",
      submitConfirm: "Submit",
      takeTitle: "Take for execution?",
      takeBody: "Assign this payment to you for execution.",
      takeConfirm: "Take",
      takeOverTitle: "Take over execution?",
      takeOverBody:
        "This payment is already in progress with another executor. Taking over will close their attempt and start a new one for you.",
      takeOverBodyWithExecutor:
        "This payment is currently being executed by {{name}}. Taking over will close their attempt and start a new one for you.",
      approveCommentOptionalHint: "Optional. Visible to the team in payment history.",
      creditCheckTitle: "Complete recipient credit check?",
      creditCheckBody:
        "Record that the required recipient credit check has been completed for this payment.",
      creditCheckConfirm: "Confirm check",
      creditCheckCancel: "Cancel",
      closeTitle: "Close this payment?",
      closeBody:
        "This finalizes the payment. No further actions will be available after closing.",
      closeConfirm: "Close payment",
      closeCancel: "Cancel",
      deleteTitle: "Delete intermediary payment?",
      deleteBody:
        "Are you sure you want to delete this intermediary payment? This action cannot be undone.",
      deleteConfirm: "Delete",
      deleteCancel: "Cancel",
      cancelTitle: "Cancel this payment?",
      cancelBody: "The payment will be marked as cancelled and will not be executed.",
      cancelConfirm: "Cancel payment",
      cancelDismiss: "Keep payment",
      executorReturnTitle: "Return payment to queue?",
      executorReturnBody:
        "Release this payment so another executor can take it. Add a short note for the team.",
      executorReturnConfirm: "Return to queue",
      executorReturnCancel: "Cancel",
      executeTitle: "Record execution result",
      executeBody: "Record how this payment was executed.",
      executeConfirm: "Record result",
      executeCancel: "Cancel",
      executeResultLabel: "Result",
      executeResultPlaceholder: "Select result",
      executeResultRequired: "Select an execution result.",
      executeResultTransferred: "Transferred",
      executeResultPaymentError: "Payment error",
      executeResultOutcomeUnknown: "Outcome unknown",
      executeResultPaymentReturned: "Payment returned",
      executeActualAmountLabel: "Actual amount",
      executeActualDateLabel: "Actual date",
      executeActualDatePlaceholder: "Select date",
      executeBankReferenceLabel: "Bank operation reference",
      creditCheckViewDocument: "View document",
      executeReasonWaitingBackend: "A reason is required for this result, but comment persistence is waiting for backend support.",
      cancelCommentLabel: "Comment (optional)",
      cancelCommentWaitingBackend: "Optional comments on cancel are waiting for backend support. Your note is shown here only and is not sent with the request.",
      creditCheckAddBody: "Attach a supporting document for this confirmed credit check.",
      creditCheckAddConfirm: "Add document",
      creditCheckAddTitle: "Add credit check document?",
      creditCheckAttachChargeInvoiceBody: "Attach a supporting document for this charge-invoice-paid credit check confirmation.",
      creditCheckAttachChargeInvoiceConfirm: "Attach document",
      creditCheckAttachChargeInvoiceTitle: "Attach document?",
      creditCheckAttachmentInvalid: "Select a valid file.",
      creditCheckAttachmentLabel: "Supporting file (optional)",
      creditCheckAttachmentSelect: "Select file",
      creditCheckAttachmentSize: "File must be 10 MB or smaller.",
      creditCheckAttachmentType: "Unsupported file type. Allowed: pdf, jpg, jpeg, png, doc, docx, xls, xlsx.",
      creditCheckAttachmentWaitingBackend: "File upload for credit check is not available yet.",
      creditCheckAttachRfBody: "Attach a supporting document for this automatically confirmed credit check.",
      creditCheckAttachRfConfirm: "Attach document",
      creditCheckAttachRfTitle: "Attach document?",
      creditCheckExistingDocument: "Current document:",
      creditCheckOptionalBody: "Optionally attach a supporting document for this credit check.",
      creditCheckOptionalConfirm: "Attach document",
      creditCheckOptionalTitle: "Attach optional document?",
      creditCheckReplaceBody: "Upload a new file to replace the existing credit check document.",
      creditCheckReplaceConfirm: "Replace document",
      creditCheckReplaceTitle: "Replace credit check document?",
      executeActualAmountPositive: "Enter an actual amount greater than zero.",
      executeAttachmentInvalid: "Select a valid file.",
      executeAttachmentLabel: "Supporting file (optional)",
      executeAttachmentRetry: "Retry file upload",
      executeAttachmentRetryHint: "Execution result was saved. Fix the file or try again to upload without recording execution again.",
      executeAttachmentSize: "File must be 10 MB or smaller.",
      executeAttachmentType: "Unsupported file type. Allowed: pdf, jpg, jpeg, png, doc, docx, xls, xlsx.",
      executeCommentLabel: "Reason",
      executeCommentOptionalLabel: "Comment (optional)",
      executeCommentRequired: "Enter a reason.",
      outcomeResolutionBody: "Confirm what happened before any retry. Do not record another transfer while the outcome is unknown.",
      outcomeResolutionConfirm: "Confirm resolution",
      outcomeResolutionLabel: "Resolution",
      outcomeResolutionNotSent: "Payment not sent",
      outcomeResolutionPlaceholder: "Select resolution",
      outcomeResolutionRequired: "Select how to resolve this outcome.",
      outcomeResolutionSent: "Payment sent (transferred)",
      outcomeResolutionStillUnknown: "Still unknown",
      outcomeResolutionTitle: "Resolve outcome",
      outcomeResolutionWaitingBackend: "Outcome resolution is not available yet.",
      paymentExecutedBody: "This confirms the payment lifecycle is complete. Proof of payment remains optional.",
      paymentExecutedConfirm: "Payment executed",
      paymentExecutedDismiss: "Not yet",
      paymentExecutedTitle: "Mark payment as executed?",
      executeCommentWaitingBackend: "Execution comments are waiting for backend support. Required reasons cannot be sent yet; your text is kept on this form only.",
    },
    actions: {
      edit: "Edit",
      submit: "Submit for approval",
      delete: "Delete",
      cancel: "Cancel payment",
      approve: "Approve",
      return: "Return",
      reject: "Reject",
      take: "Take for execution",
      execute: "Add execution result",
      recordPaymentReturn: "Record payment return",
      executorReturn: "Return to queue",
      uploadProof: "Upload proof",
      creditCheck: "Credit check",
      completeCreditCheck: "Complete credit check",
      close: "Close",
      closePayment: "Close payment",
      addCreditCheckDocument: "Add document",
      attachCreditCheckDocument: "Attach document",
      attachOptionalCreditCheckDocument: "Attach optional document",
      editPayment: "Edit payment",
      paymentExecuted: "Payment executed",
      replaceCreditCheckDocument: "Replace document",
      replaceProof: "Replace proof",
      resolveOutcome: "Resolve outcome",
      revise: "Revise",
    },
    wizard: {
      createTitle: "Create intermediary payment",
      createSubtitle:
        "Prepare an intermediary payment linked to a request of funds and/or a charge invoice. Complete each step before saving a draft.",
      backToList: "Intermediary payments",
      fundRequestLabel: "Request of funds",
      fundRequestPlaceholder: "Select request of funds",
      chargeInvoiceLabel: "Charge invoice",
      chargeInvoicePlaceholder: "Select charge invoice",
      chargeInvoiceNoResults: "No charge invoices found",
      fundRequestsUnavailable:
        "Fund requests for new intermediary payments are not available yet. Try again later.",
      rfNumber: "Number",
      availablePool: "Available pool",
      amountCurrencyHint: "Currency: {{currency}} (from request of funds).",
      recipientReferenceHint:
        "Reference the recipient expects on the payment — not the bank wire reference.",
      executorLabel: "Executor",
      executorHint: "Optional for draft. Required before submit for approval.",
      creditCheckRequiredLabel: "Recipient credit check required",
      creditCheckRequiredCheckbox: "Require credit check before this payment can be closed",
      draftCreateSuccess: "Intermediary payment draft created successfully.",
      draftCreateError: "Could not save intermediary payment draft.",
      editTitle: "Edit intermediary payment",
      editSubtitle:
        "Update payment details and assignments. Only changed fields are sent to the server.",
      editApprovalWarning: "Editing certain fields may reset payment approval.",
      editSaveSuccess: "Intermediary payment updated successfully.",
      editSaveError: "Could not save intermediary payment changes.",
      errorFundRequestRequired: "Select a request of funds.",
      errorSourceRequired: "Select a request of funds and/or a charge invoice.",
      errorChargeInvoiceRequired: "Select a charge invoice.",
      errorFundRequestPreselectInvalid:
        "The request of funds in the link is not available for a new payment.",
      errorAmountRequired: "Enter a positive amount with up to two decimal places.",
      errorRequisitesRequired: "Bank details are required.",
      errorRecipientReferenceRequired: "Recipient reference is required.",
      errorPurposeRequired: "Purpose is required.",
      steps: {
        payment_details: "Payment details",
        payment_detailsDescription:
          "Link to a request of funds and/or charge invoice and enter recipient payment information.",
        assignment: "Assignment & instructions",
        assignmentDescription: "Ownership, deadlines, and internal payment instructions.",
      },
      stepsAria: "Wizard steps",
      modeOfPaymentLabel: "Mode of Payment",
      errorCurrencyRequired: "Select a currency.",
      chargeInvoiceSummaryAria: "Charge invoice summary",
      chargeInvoiceSummaryEmpty: "No charge invoice details are available.",
      chargeInvoiceSummaryError: "Could not load charge invoice details.",
      chargeInvoiceSummaryLoading: "Loading charge invoice details",
      costCurrencyPlaceholder: "Select currency",
      creditCheckRequiredTooltip: "If respective request of funds money received in full",
      currencyFallbackNotice: "Could not load currencies from the server. Showing a limited fallback list.",
      draftSaveBlockedPendingBackend: "Saving a draft is temporarily unavailable: cost currency, mode of payment, supporting files, multi-executor assignment, and updated payment details are not yet supported by the API. Your entries are kept on this page only.",
      editApprovalConfirmTitle: "Save changes?",
      editSaveBlockedPendingBackend: "Saving changes is temporarily unavailable: cost currency, mode of payment, supporting files, multi-executor assignment, and updated payment details are not yet supported by the API. Your entries are kept on this page only.",
      errorCostAmountRequired: "Enter a positive cost amount with up to two decimal places.",
      errorExecutorPending: "Wait for executors to load or choose a valid executor.",
      errorExecutorRequired: "Select at least one executor.",
      errorModeOfPaymentRequired: "Select a mode of payment.",
      errorRecipientNameRequired: "Enter a recipient name.",
      errorRecipientNameTooLong: "Recipient must be {{max}} characters or fewer.",
      errorRecipientRequisitesRequired: "Enter recipient banking details.",
      executorMultiPlaceholder: "Select executors",
      fundRequestNoResults: "No request of funds found",
      modeOfPaymentPlaceholder: "Select mode of payment",
      parentDocumentLabel: "Parent Document (Request of Funds)",
      parentSummaryAria: "Parent document summary",
      parentSummaryClient: "Client",
      parentSummaryClientUnavailable: "Not available",
      parentSummaryDocument: "Document",
      parentSummaryEmpty: "No parent document details are available.",
      parentSummaryError: "Could not load parent document details.",
      parentSummaryLineItems: "Line items",
      parentSummaryLoading: "Loading parent document details",
      parentSummaryNoLineItems: "No line items on this document.",
      parentSummaryTotal: "Total amount",
      paymentErrorCorrectionIntro: "Update banking details and instructions before retrying. Amount, currency, and executors stay locked.",
      paymentErrorCorrectionNoChanges: "Change at least one field before saving.",
      paymentErrorCorrectionSubtitle: "Payment error — correct instructions before retrying execution.",
      paymentErrorCorrectionTitle: "Correct payment instructions",
      paymentErrorCorrectionUnavailable: "Payment correction is no longer available for this payment.",
      reviseIntro: "Update only the fields requested during approval review. Other payment details stay locked.",
      revisePanelTitle: "Revision details",
      reviseSubtitle: "Returned for revision — limited fields can be updated.",
      reviseTitle: "Revise intermediary payment",
      revisionNoChanges: "Change at least one revision field before saving.",
      revisionParentRfSummaryAria: "Parent request of funds summary",
      revisionParentRfTitle: "Parent Request of Funds",
      revisionResubmitNoChanges: "Change at least one field before resubmitting.",
      revisionSubmitAfterSaveHint: "After a successful save, Submit for approval will appear on the payment detail page.",
      supportingDownloadError: "Could not download supporting file.",
      supportingFilesLabel: "Supporting files",
      supportingLocalNotUploaded: "Selected — not yet uploaded",
      supportingPersistedOnServer: "Saved on server",
      supportingRemoveFile: "Remove file",
      supportingReplaceFile: "Replace file",
      supportingSelectFile: "Select file",
      supportingUploadError: "Draft was saved but the supporting file could not be uploaded.",
      supportingUploadRetryHint: "Fix the file and save again to retry the upload without creating another draft.",
      errorCostCurrencyRequired: "Select a cost currency.",
    },
    form: {
      recipient: "Recipient",
      requisites: "Bank details",
      recipientReference: "Recipient reference",
      purpose: "Purpose",
      amount: "Amount",
      effectiveDeadline: "Deadline",
      instruction: "Payment instruction",
      save: "Save draft",
      saveChanges: "Save changes",
      errorRecipient: "Recipient is required.",
      costAmount: "Amount",
      costCurrency: "Currency",
      descriptionPurpose: "Description (Purpose)",
      paymentInstruction: "Payment instruction",
      recipientBankingDetails: "Recipient banking details (IBAN / BIC)",
      recipientName: "Recipient",
      modeOfPayment: "Payment method",
    },
    source: {
      chargeInvoiceFallback: "Charge invoice",
      typeChargeInvoice: "Charge invoice",
      typeFundRequest: "Request of funds",
      typeCombined: "Request of funds and charge invoice",
    },
    detail: {
      title: "Intermediary payment",
      notFound: "Payment not found.",
      back: "Intermediary payments",
      closed: "Closed",
      copy: "Copy",
      copyToClipboard: "Copy {{label}}",
      copiedToClipboard: "Copied {{label}}",
      documentKicker: "Payment to",
      documentTitle: "Payment instruction",
      documentAria: "Intermediary payment instruction document",
      bankingSection: "Banking information",
      totalPayment: "TOTAL PAYMENT",
      totalPaymentLabel: "Total payment",
      statusPanelTitle: "Status and ownership",
      workflowPanelTitle: "Workflow & activity",
      ownershipSectionTitle: "Ownership",
      approvalStatusSectionTitle: "Approval status",
      executionStatusSectionTitle: "Execution status",
      creditCheckRequiredBeforeClose:
        "Recipient credit check is required before closing this payment.",
      proofEmpty: "No proof attached",
      rejectedAt: "Rejected",
      creditCheckLabel: "Credit check",
      creditCheckBadgeRequired: "Required",
      paymentSection: "Payment information",
      assignmentSection: "Assignment",
      approvalSection: "Approval",
      executionSection: "Execution details",
      entitySection: "Entity and period",
      recipientSection: "Recipient & payment",
      scheduleSection: "Deadlines & ownership",
      instructionSection: "Instruction & execution",
      amount: "Amount",
      actualAmount: "Actual amount",
      paidFor: "Paid for",
      taxNumber: "Tax number",
      period: "Period",
      fundRequest: "Request Funds",
      sourceType: "Source type",
      chargeInvoice: "Charge invoice",
      closedChargeInvoiceWarning:
        "The linked charge invoice is voided or refunded. Review the payment before proceeding.",
      creditCheckConfirmedByChargeInvoice: "Charge invoice paid",
      creditCheckConfirmedByChargeInvoiceHint:
        "Linked charge invoice is paid. No further credit check action is required in the UI.",
      submittedAt: "Submitted",
      approvedAt: "Approved",
      approver: "Approver",
      approvalComment: "Approval comment",
      executedOn: "Actual date",
      executedBy: "Executed by",
      bankReference: "Bank reference",
      proof: "Payment proof",
      proofView: "View",
      proofOpenAction: "Open payment proof",
      creditCheck: "Credit check status",
      creditCheckRequired: "Credit check required",
      creditCheckPassed: "Passed",
      creditCheckPending: "Not run",
      creditCheckRequiredPending: "Required — not completed",
      creditCheckRequiredLabel: "Credit check required",
      creditCheckAwaiting: "Awaiting check",
      creditCheckCompleted: "Completed",
      creditCheckStatusLabel: "Status",
      recipientCreditCheckTitle: "Recipient credit check",
      executionActivityTitle: "Execution activity",
      executionResultLabel: "Execution result",
      proofUploadedBy: "Proof uploaded by",
      proofUploadedAt: "Proof uploaded at",
      creditCheckNotRequired: "Not required",
      creditCheckedBy: "Credit checked by",
      creditCheckedAt: "Credit checked at",
      creditCheckStatus: "Status",
      progressAria: "Payment progress",
      createdAt: "Created",
      updatedAt: "Updated",
      attemptEndReasons: {
        executor_returned: "Executor returned",
        taken_over: "Taken over",
      },
      attemptResolutionOutcome: {
        not_sent: "Payment not sent",
        sent: "Payment sent",
        unknown: "Still unknown",
      },
      attemptSnapshotPaymentMethod: "Payment method",
      attemptSnapshotRecipient: "Recipient",
      attemptSnapshotBankingDetails: "Banking details",
      attemptSnapshotRecipientReference: "Recipient reference",
      attemptSnapshotPaymentInstruction: "Payment instruction",
      activeExecutor: "Active executor",
      activeExecutorNotTaken: "Not taken yet",
      activitySectionTitle: "Activity",
      assignedExecutors: "Assigned executors",
      attemptAddFile: "Add file",
      attemptComment: "Comment",
      attemptCurrent: "Current",
      attemptDeleteFile: "Delete file",
      attemptDeleteFileConfirmAction: "Delete",
      attemptDeleteFileConfirmBody: "This file will be removed from the execution attempt.",
      attemptDeleteFileConfirmTitle: "Delete this file?",
      attemptDocuments: "Documents",
      attemptEndedAt: "Ended at",
      attemptEndReason: "End reason",
      attemptExecutionPaymentDetailsTitle: "Payment details at execution",
      attemptExecutor: "Executor",
      attemptFollowUpActor: "Actor",
      attemptFollowUpChecksHint: "Additional still-unknown outcome notes recorded in payment history.",
      attemptFollowUpChecksTitle: "Follow-up checks",
      attemptFollowUpComment: "Comment",
      attemptFollowUpDate: "Date/time",
      attemptHistoryLoading: "Loading follow-up history…",
      attemptLatestResolutionHint: "Outcome clarified on this attempt — not a new payment attempt.",
      attemptLatestResolutionTitle: "Latest resolution",
      attemptNumber: "Attempt #{{number}}",
      attemptOriginalExecutionHint: "As recorded when the executor submitted this attempt.",
      attemptOriginalExecutionTitle: "Original execution result",
      attemptResolutionComment: "Resolution comment",
      attemptResolvedAt: "Resolved at",
      attemptResolvedBy: "Resolved by",
      attemptResult: "Result",
      attemptResultClarified: "{{from}} → {{to}} (clarified)",
      attemptReturnComment: "Return comment",
      attemptReturnedAt: "Returned at",
      attemptReturnedBy: "Returned by",
      attemptTakenAt: "Taken at",
      cancelComment: "Cancel comment",
      cancelledAt: "Cancelled",
      cancelledBy: "Cancelled by",
      createdBy: "Created by",
      creditCheckConfirmedByRf: "Confirmed",
      creditCheckConfirmedByRfHint: "Linked request of funds is fully received. No further credit check action is required in the UI.",
      creditCheckDocument: "Document",
      executionAttemptsTitle: "Execution attempts",
      linkedRfStatusUnavailable: "Status unavailable",
      rejectionReason: "Rejection reason",
      returnComment: "Return comment",
      supportingDocument: "Supporting document",
      creditCheckDocumentLink: "Download",
    },
    common: {
      waitingForBackend: "Waiting for backend support.",
    },
    modeOfPayment: {
      bankTransfer: "Bank transfer",
      cardPayment: "Card payment",
    },
  },
  proforma: {
    addonsLabel: "Add-ons:",
    viewPayment: "View",
  },
  filters: {
    searchPlaceholder: "Search",
    proformaSearchPlaceholder: "Search by invoice number or name",
    dateRangeLabel: "Date range",
    dateFrom: "From",
    dateTo: "To",
    sortByStatus: "Filter by status",
    sortByStatusPrefix: "Sort by status:",
    statusAll: "All",
    showAll: "Show all",
    appsPrefix: "Apps:",
    proformaStatusNew: "New",
    proformaStatusProcessed: "Processed",
    proformaStatusVoided: "Voided",
    proformaStatusRefund: "Refund",
    proformaStatusBalanceRefund: "Balance refund",
    proformaAppLTax: "L'Tax",
    proformaAppLEpr: "L'EPR",
    proformaAppLInvoice: "L'Invoice",
    proformaAppLAuthorize: "L'Authorize",
    advancedFiltersTrigger: "Advanced filters",
    advancedFiltersTitle: "Advanced filters",
    advanced: {
      subscriptionType: "Subscription type",
      subscriptionPlaceholder: "Select subscription",
      addons: "Add-ons",
      addonsPlaceholder: "Select add-ons",
      amount: "Amount",
      amountPlaceholder: "Enter amount",
      optionNone: "\u2014",
      addonMockReports: "Reporting",
      addonMockCompliance: "Compliance",
    },
  },
  filterTabs: {
    moreOptions: "More options",
  },
  statuses: {
    PAID: "Paid",
    PENDING: "Pending",
    OPEN: "Open",
    COMPLETED: "Completed",
    CLOSED: "Closed",
    FAILED: "Failed",
    CANCELLED: "Cancelled",
    paid: "Paid",
    due: "Due",
    credited: "Credited",
    processed: "Processed",
    completed: "Completed",
    complete: "Complete",
    money_received: "Money Received",
    received: "Received",
    pending: "Pending",
    pending_payment: "Pending Payment",
    new: "New",
    voided: "Voided",
    refund: "Refund",
    balance_refund: "Balance Refund",
    awaiting_funds: "Awaiting Funds",
    partially_received: "Partially Received",
    fully_received: "Fully Received",
    open: "Open",
    closed: "Closed",
    failed: "Failed",
    cancelled: "Cancelled",
    draft: "Draft",
    overdue: "Overdue",
    unpaid: "Unpaid",
    partially_paid: "Partially Paid",
  },
  statusFilter: {
    ALL: "All",
    PAID: "Paid",
    PENDING: "Pending",
    OPEN: "Open",
    COMPLETED: "Completed",
    CLOSED: "Closed",
  },
  table: {
    created: "Created",
    invoiceName: "Invoice name",
    creditNoteName: "Credit note name",
    relatedInvoice: "Related invoice",
    number: "Number",
    billingPeriod: "Billing period",
    status: "Status",
    payment: "Payment",
    app: "App",
    amount: "Amount",
    actions: "Actions",
  },
  linkedProformaBanner: {
    label: "Related proforma invoice:",
  },
  linkedPaymentBanner: {
    label: "Related payment:",
  },
  linkedTaxInvoiceBanner: {
    label: "Related tax invoice:",
  },
  contextualPkBanner: {
    clearFilter: "Clear filter",
  },
  billingTableEmpty: {
    title: "No items found",
    proformaTitle: "No items found",
    proformaEmptyDescription: "You currently do not have Proforma invoices",
    requestFundsEmptyDescription: "You currently do not have request funds",
    emptyNoSearch: "You currently do not have {{entity}}.",
    noItemsToDisplay: "There are no items to display.",
    searchNoMatch: 'Your search "{{query}}" did not match any items.',
    filtersNoMatch: "No items match the selected filters.",
    clearSearch: "Clear search",
    clearFilters: "Clear filters",
    entities: {
      _default: "records for this tab",
      PROFORMA: "proforma invoices",
      TAX: "tax invoices",
      CREDIT_NOTE: "credit notes",
      PAYMENTS: "payments",
      REQUEST_FUNDS: "request funds",
      CREDITS_SUMMARY: "credits summary entries",
    },
  },
  loading: "Loading billing history…",
  error: "We could not load billing history. Please try again.",
  retry: "Retry",
  tabsCheckup: {
    noneAvailableTitle: "No billing history available",
    noneAvailableDescription:
      "There are no billing history sections available for this company yet.",
    errorTitle: "Could not load billing history",
    errorDescription:
      "We could not determine which sections are available. Please try again.",
  },
  billingRowActions: {
    viewDetails: "View details",
    view: "View",
    pay: "Pay",
    edit: "Edit",
    void: "Void",
    restore: "Restore",
    download: "Download",
    delete: "Delete",
  },
  taxDownload: {
    error: "Could not download the file. Please try again.",
  },
  proformaDownload: {
    error: "Could not download the file. Please try again.",
  },
  requestFundsDownload: {
    error: "Could not download the file. Please try again.",
  },
  rowActions: {
    download: "Download",
    view: "View details",
    copyNumber: "Copy invoice number",
  },
  requestFunds: {
    addRequestFunds: "Add request funds",
    create: {
      drawerTitle: "Add request funds",
      cancel: "Cancel",
      create: "Create",
      currencyLabel: "Currency",
      requestTypeLabel: "Request type",
      paymentPurposeLabel: "Payment purpose",
      dateLabel: "Date",
      datePlaceholder: "Select date",
      requestNumberLabel: "Request number",
      descriptionLabel: "Description",
      jurisdictionLabel: "Jurisdiction",
      jurisdictionPlaceholder: "Select jurisdiction",
      stateLabel: "State",
      provinceStateLabel: "Province / State",
      stateProvinceLabel: "State / Province",
      statePlaceholder: "Select state / province (optional)",
      stateLoadingPlaceholder: "Loading…",
      requestedAmountLabel: "Requested amount",
      receivedAmountLabel: "Received amount",
      balanceLabel: "Balance",
      statusLabel: "Status",
      statusPendingPayment: "Pending payment",
      statusReceived: "Received",
      statusCompleted: "Completed",
      errorGeneric: "Could not create request funds.",
      errorCurrencyRequired: "Select a currency.",
      errorRequestTypeRequired: "Select a request type.",
      errorDateRequired: "Select a date.",
      errorRequestNumberRequired: "Enter the request number.",
      errorDescriptionRequired: "Enter a description.",
      errorJurisdictionRequired: "Select a jurisdiction.",
      errorAmountRequired: "Enter the amount.",
      errorAmountInvalid: "Enter a valid number.",
      errorStatusRequired: "Select a status.",
      requestDetailsSection: "Request details",
      lineItemsSection: "Line items",
      paymentDetailsSection: "Payment details",
      lineItemDescriptionLabel: "Description",
      lineItemAmountLabel: "Amount",
      errorQuantityInvalid: "Enter a valid quantity.",
      errorUnitPriceRequired: "Enter the unit price.",
      addLineItem: "Add line item",
      addItem: "Add item",
      addToList: "Add to list",
      removeLineItem: "Remove line item",
      removeItem: "Remove",
      totalLabel: "Total",
      bankLabel: "Bank",
      bankPlaceholder: "Select bank",
      errorLineItemRequired: "Enter a description.",
      errorLineItemsRequired: "Add at least one line item.",
      errorBankRequired: "Select a bank.",
      additionalDetailsSection: "Additional details",
      clientPaymentDeadlineLabel: "Client payment deadline",
      clientPaymentDeadlinePlaceholder: "Select date",
      transferDeadlineLabel: "Transfer deadline",
      transferDeadlinePlaceholder: "Select date",
      responsibleLabel: "Responsible",
      responsiblePlaceholder: "Select manager",
      deputyLabel: "Deputy",
      deputyPlaceholder: "Select manager",
      periodLabel: "Period",
      purposeLabel: "Purpose",
      errorFundManagers: "Could not load fund managers.",
      errorRequestNumberConflict: "This request number is already in use.",
      jurisdictionNoResults: "No jurisdictions found",
    },
    edit: {
      errorFieldCannotBeCleared: "This field can't be cleared.",
      errorGeneric: "Could not update request funds.",
      cancel: "Cancel",
      drawerTitle: "Edit request funds",
      save: "Save",
    },
    wizard: {
      createTitle: "Create request of funds",
      editTitle: "Edit request of funds",
      createRequest: "Create request of funds",
      saveChanges: "Save changes",
      next: "Next",
      back: "Back",
      backToList: "Request funds",
      accessDenied: "You do not have access.",
      legacyClosed: "This request is closed.",
      steps: {
        general: "General information",
        generalDescription:
          "Payment purpose, currency, request number, date, and jurisdiction.",
        bank: "Bank details",
        bankDescription: "Select the bank account for this request.",
        line_items: "Line items",
        line_itemsDescription: "Add invoice-style line items and review the total.",
        details: "Request details",
        detailsDescription:
          "Deadlines, responsible party, period, and purpose.",
        detailsCreateDescription:
          "Deadlines, responsible party, period, and purpose.",
        supporting: "Supporting information",
        supportingDescription: "Description and supporting attachments.",
        supportingCreateDescription: "Description and supporting attachments.",
        review: "Review & submit",
        reviewDescription: "Review the information before creating your request.",
      },
      bank: {
        optionalNotice:
          "A bank account is optional for this payment purpose. You may continue without selecting one.",
        detailsCardTitle: "Bank account details",
        bankName: "Bank name",
        accountName: "Account name",
        iban: "IBAN",
        bicSwift: "BIC / SWIFT",
        accountNumber: "Account number",
        sortCode: "Sort code",
        branch: "Branch",
        bankIdentifier: "Bank identifier",
        clearSelection: "Clear bank selection",
        defaultBadge: "Default",
        defaultUkBadge: "UK default",
        detailsEmpty: "No bank details are available for this account.",
        detailsLoadError: "Could not load bank details. Try selecting the bank again.",
        detailsLoading: "Loading bank details…",
        emptyList: "No bank accounts are available.",
        loading: "Loading bank accounts…",
      },
      lineItems: {
        quantityLabel: "Qty",
        unitPriceLabel: "Unit price",
        subtitle: "Add the expenses covered by this request.",
        deleteRowLabel: "Delete line item",
        optionalNotice:
          "Line items are optional for this payment purpose. You may continue without adding rows.",
        addNewLine: "Add new line",
        emptyPlaceholder: "No line items yet. Click to add the first line item.",
        edit: "Edit",
        delete: "Delete",
        resourceSingular: "line item",
        resourcePlural: "line items",
      },
      supporting: {
        headingTooltip: "Visible for Lappa team only",
        descriptionPendingSave:
          "Changes to this field are not yet saved — pending backend support.",
        attachmentLabel: "Supporting file",
        selectFile: "Select file",
        replaceFile: "Replace",
        removeFile: "Remove",
        localFileNotUploaded: "Selected — not yet uploaded",
        downloadServerFile: "Download saved attachment",
        notApplicable: "Line items and bank are not required for this request type.",
        addFiles: "Add files",
        uploadRetryCta: "Retry upload",
        uploadRetryMessage: "The request was created but supporting files could not be uploaded.",
      },
      reviewPreparedForReview: "Information prepared for review",
      reviewPreviewStatus: "Preview only · Document not yet generated",
      reviewDocumentTitleUpper: "Request of Funds",
      reviewContextTitle: "Request context",
      reviewPaymentDetailsTitle: "Payment details",
      reviewInternalTitle: "Internal information (managers only)",
      reviewAssignmentTitle: "Assignment",
      reviewBankTitle: "Bank details",
      submitBlocked: {
        title: "Submit is disabled until the following are resolved:",
        paymentPurpose:
          "Payment purpose must be Tax Payment or Deposit / Guarantee until the backend supports additional types.",
        lineItemQtyUnitPrice:
          "Line items must use quantity 1 with unit price equal to amount until the backend accepts quantity and unit price.",
        bankChange:
          "Bank account changes cannot be saved until the backend accepts data updates.",
        lineItemsChange:
          "Line item changes cannot be saved until the backend accepts data updates.",
        descriptionChange:
          "Description changes cannot be saved until the backend accepts description updates.",
        localFile:
          "Remove the locally selected file — file upload is not available yet.",
      },
      review: {
        documentTitle: "Request of Funds",
        requestNumber: "Request number",
        date: "Date",
        requestType: "Request type",
        currency: "Currency",
        jurisdiction: "Jurisdiction",
        requestDetails: "Request details",
        supportingInformation: "Supporting information",
        noLineItems: "No line items added.",
      },
      lineItemModal: {
        addTitle: "Add line item",
        editTitle: "Edit line item",
        cancel: "Cancel",
        add: "Add",
        save: "Save",
      },
      lineItemDelete: {
        title: "Delete line item?",
        description: "This line item will be removed from the request.",
        descriptionWithItem: "Are you sure you want to delete '{{description}}'?",
        cancel: "Cancel",
        confirm: "Delete",
      },
      stepsAria: "Wizard steps",
      lineItemAdd: "Add",
      lineItemAddTitle: "Add line item",
      lineItemEditTitle: "Edit line item",
      lineItemSave: "Save",
      reviewDocumentAria: "Request of funds document preview",
      reviewNoLineItems: "No line items added.",
      reviewSupportingTitle: "Supporting information",
      totalRequestAmountLabel: "Total request amount",
    },
    filters: {
      sortByStatusPrefix: "Sort by status:",
      overduePrefix: "Overdue:",
      overdueShowAll: "Show all",
      overdueOnly: "Overdue only",
      requestTypeAll: "All",
      requestTypeDeposit: "Deposit / Guarantee",
      requestTypePrefix: "Request type:",
    },
    table: {
      created: "Created",
      description: "Description",
      jurisdiction: "Jurisdiction",
      number: "Number",
      document: "Document",
      requested: "Requested",
      received: "Received",
      balance: "Balance",
      overdueBadge: "Overdue",
      legacyClosedBadge: "Legacy closed",
    },
    emailSend: {
      saveAsDraft: "Save as draft",
      saveAndSend: "Save & send",
      send: "Send",
      sendViaEmail: "Send via email",
      resend: "Resend",
      deliveryConfirmed: "Sent",
      deliveryNotConfirmed: "Delivery not confirmed, check later",
      noRecipientsSaveAsDraft: "You can save as draft instead.",
      errorGeneric: "Could not send the request.",
      resendConfirmTitle: "Resend request email?",
      resendConfirmDescription:
        "This will queue another email to company Owner/Finance users. Continue?",
      resendConfirmCancel: "Cancel",
      resendConfirmSend: "Resend",
      detailStatusLabel: "Email delivery",
      detailStatusSent: "Sent",
      detailStatusNotSent: "Not sent",
      detailLastSentLabel: "Last sent",
      detailLastSentWithSender: "{{date}} by {{name}}",
    },
    document: {
      noDocument: "No document",
      sentToClient: "Sent to client",
      sentShort: "Sent",
      notSent: "Not sent",
      sending: "Sending…",
      pdfLink: "PDF",
      hint: {
        noDocument: "No system document for this request",
        sent: "PDF emailed to company Owner/Finance users",
        notSent: "PDF has not been delivered to the client yet",
        sending: "Delivering PDF to client users",
      },
    },
    summary: {
      availableCaption: "Available",
    },
    detail: {
      title: "Request of Funds",
      backLabel: "Request Funds",
      createdPrefix: "Created",
      notFound: "Request not found.",
      document: {
        label: "Document",
        requestFile: "Request file",
        colAmount: "Amount",
        colDescription: "Description",
        colNo: "No",
      },
      overview: {
        heading: "Overview",
        number: "Number",
        description: "Description",
        jurisdiction: "Jurisdiction",
        created: "Created",
        requested: "Requested",
        received: "Received",
        balance: "Balance",
        shortfall: "Shortfall",
        overpayment: "Overpayment",
        basisFile: "Basis file",
        downloadBasisFile: "Download basis file",
        editAction: "Edit",
        deleteAction: "Delete",
        supportingFiles: "Supporting files",
      },
      availablePool: {
        label: "Available pool",
      },
      countryLabel: "Country",
      createdLabel: "Created",
      currencyLabel: "Currency",
      descriptionLabel: "Description",
      documentAria: "Request of Funds financial document",
      financial: {
        amountDue: "AMOUNT DUE",
        heading: "Payment summary",
        overpayment: "Overpayment",
        received: "Received",
        requestedAmount: "Requested amount",
        shortfall: "Shortfall",
        lessPayments: "Less: Payments",
        lessPayment: "Less: Payment · {{date}}",
      },
      recordPayment: {
        amountPaidLabel: "Amount paid",
        bankReferenceLabel: "Bank reference",
        confirmationFileLabel: "Confirmation file",
        cta: "Add payment",
        currencyLabel: "Currency",
        datePaidLabel: "Date paid",
        heading: "Record client payment",
        remainingHint: "Remaining balance: {{amount}}",
        submit: "Record payment",
      },
    },
    summaryCards: {
      available: "Available",
    },
    statusLabels: {
      awaiting_funds: "Awaiting funds",
      partially_received: "Partially received",
      fully_received: "Fully received",
    },
    bankRequisites: {
      beneficiary: "Beneficiary",
      account_number: "Account number",
      iban: "IBAN",
      sort_code: "Sort code",
      swift_bic: "SWIFT / BIC",
      routing_number: "Routing number",
      beneficiary_address: "Beneficiary address",
      beneficiary_bank: "Bank / Payment institution",
      bank_address: "Bank / Payment institution address",
      currency: "Currency",
      reference: "Reference",
    },
    delete: {
      cancel: "Cancel",
      delete: "Delete",
      description: "Are you sure you want to delete this request funds item? This action cannot be undone.",
      errorGeneric: "Could not delete request funds. Please try again.",
      title: "Delete request funds?",
    },
    viewDetailRowAction: "View request",
    requestType: {
      taxLegacy: "Tax (legacy)",
    },
  },
  clientPayments: {
    sectionTitle: "Client payments",
    confirmationFile: "View file",
    rowAction: "Client payments",
    viewRowAction: "View payments",
    drawerTitleManager: "Client payments",
    drawerTitleClient: "Payments",
    close: "Close",
    addPayment: "Add payment",
    empty: "No client payments yet.",
    list: {
      date: "Date",
      bankReference: "Bank reference",
      confirmation: "Confirmation",
      confirmationFile: "Confirmation file",
      amount: "Amount",
      status: "Status",
      actions: "Actions",
      void: "Void",
      voidPayment: "Void payment",
      statusVoided: "Voided",
      statusActive: "Active",
      viewShort: "View",
    },
    add: {
      title: "Add client payment",
      cancel: "Cancel",
      submit: "Add payment",
      amountLabel: "Amount",
      currencyLabel: "Currency",
      dateLabel: "Date",
      datePlaceholder: "Select date",
      bankReferenceLabel: "Bank reference (optional)",
      confirmationFileLabel: "Confirmation file (optional)",
      addFile: "Add file",
      replaceFile: "Replace file",
      removeFile: "Remove",
      errorGeneric: "Could not add client payment.",
      errorAmountRequired: "Enter an amount greater than zero.",
      errorCurrencyRequired: "Select a currency.",
      errorDateRequired: "Select a date.",
    },
    void: {
      title: "Void client payment?",
      description: "This payment will be marked as voided.",
      cancel: "Cancel",
      confirm: "Void payment",
      reasonLabel: "Reason",
      errorGeneric: "Could not void client payment.",
      errorReasonRequired: "Enter a reason.",
    },
  },
  payments: {
    table: {
      type: "Type",
      reference: "Reference",
      paymentMethod: "Payment Method",
    },
    filters: {
      sortByPaymentMethodPrefix: "Sort by payment method:",
      sortAll: "All",
      sortCard: "Card",
      sortBankTransfer: "Bank transfer",
    },
  },
  paymentsDetails: {
    status: "Status",
    created: "Created",
    number: "Number",
    paymentMethod: "Payment Method",
    amount: "Amount",
    total: "Total",
    sectionTitle: "Payment details",
    colItem: "Item",
    colQty: "Qty",
    colPrice: "Price",
    downloadPdf: "Download PDF",
  },
  paymentsDeleteModal: {
    title: "Delete payment?",
    description:
      "Are you sure you want to delete this payment? This action cannot be undone.",
    cancel: "Cancel",
    delete: "Delete",
  },
  paymentsEdit: {
    drawerTitle: "Edit payment",
    drawerTitleWithNumber: "Edit payment {{number}}",
    cancel: "Cancel",
    save: "Save",
    paymentDateLabel: "Created date",
    paymentDatePlaceholder: "Select payment date",
    paymentNumberLabel: "Payment number",
    pdfLabel: "PDF file",
    replaceFile: "Replace file",
    removeFile: "Remove",
    errorGeneric: "Could not save changes.",
    errorPaymentDateRequired: "Select the payment date.",
    errorNumberRequired: "Enter the payment number.",
    errorSumRequired: "Enter the amount.",
    errorSumInvalid: "Enter a valid amount.",
    errorMissingType: "Payment type is missing; cannot save.",
  },
  creditsSummary: {
    cards: {
      salesTaxAvailable: "Sales Tax credits available",
      salesListAvailable: "Sales list credits available",
      creditsAvailable: "credits available",
    },
    filters: {
      sortByTypePrefix: "Sort by type:",
      sortAll: "All",
      sortSalesTax: "Sales Tax",
      sortSalesList: "Sales List",
    },
    table: {
      description: "Description",
      id: "ID",
      creditType: "Credit Type",
      creditsLeft: "Credits Left",
      amount: "Amount",
    },
  },
  taxInvoiceDetails: {
    status: "Status",
    invoiceDate: "Invoice Date",
    invoiceNumber: "Invoice Number",
    vatNumber: "VAT Number",
    sectionTitle: "Invoice details",
    colItem: "Item",
    colQty: "Qty",
    colPrice: "Price",
    total: "Total",
    downloadPdf: "Download PDF",
  },
  creditNoteDetails: {
    status: "Status",
    createdDate: "Created",
    number: "Number",
    relatedInvoice: "Related invoice",
    sectionTitle: "Credit note details",
    colItem: "Item",
    colQty: "Qty",
    colPrice: "Price",
    total: "Total",
    downloadPdf: "Download PDF",
  },
  proformaInvoiceDetails: {
    title: "Proforma invoice",
    titleWithNumber: "Proforma invoice {{number}}",
    app: "App",
    addonsHeading: "Add-ons",
    noInvoiceDetails: "No invoice details",
  },
  proformaDeleteModal: {
    title: "Delete proforma invoice",
    description:
      "This proforma invoice will be permanently deleted. This action cannot be undone.",
    descriptionWithNumber:
      "Proforma invoice {{number}} will be permanently deleted. This action cannot be undone.",
    cancel: "Cancel",
    delete: "Delete",
  },
  proformaVoidModal: {
    title: "Void proforma invoice?",
    description:
      "This action will mark the proforma invoice as voided. You can restore it later if needed.",
    descriptionWithNumber:
      "Proforma invoice {{number}} will be marked as voided. You can restore it later if needed.",
    cancel: "Cancel",
    void: "Void invoice",
    success: "Proforma invoice voided successfully.",
    errorGeneric: "Could not void this invoice. Please try again.",
  },
  proformaRestoreModal: {
    title: "Restore proforma invoice?",
    description:
      "This action will restore the proforma invoice and set its status back to New.",
    cancel: "Cancel",
    restore: "Restore invoice",
    success: "Proforma invoice restored successfully.",
    errorGeneric: "Could not restore this invoice. Please try again.",
  },
  proformaPayModal: {
    title: "Pay proforma invoice",
    description:
      "Do you want to pay proforma invoice {{number}} from {{date}} for {{amount}}?",
    numberFallback: "—",
    cancel: "Cancel",
    pay: "Pay",
    shopifyPay: "Buy now with Shopify Pay",
    errorGeneric: "Could not start payment. Please try again.",
  },
  proformaInvoiceEdit: {
    drawerTitle: "Edit proforma invoice",
    cancel: "Cancel",
    save: "Save",
    pdfLabel: "PDF invoice",
    replaceFile: "Replace file",
    removeFile: "Remove",
    errorTitle: "Save failed",
    errorGeneric: "Could not save changes.",
    errorNumberRequired: "Enter the invoice number.",
    errorSumRequired: "Enter the amount.",
    errorSumInvalid: "Enter a valid amount.",
    errorPaymentDateRequired: "Select the payment date.",
    errorUploadAfterSave: "Invoice was saved but the PDF upload failed.",
    createdDateLabel: "Created date",
    createdDatePlaceholder: "Select created date",
    paymentDateLabel: "Payment date",
    paymentDatePlaceholder: "Select payment date",
  },
  mainTabSoon: "Coming soon",
  paymentsSettings: {
    paymentMethod: {
      title: "Payment method",
      subtitle: "This card is used for subscription billing.",
      cardType: "Card type",
      cardNumber: "Card number",
      expirationDate: "Expiration date",
      exp: "Exp",
      expShort: "Exp {{exp}}",
      expLabel: "Exp: {{exp}}",
      cardPreviewLabel: "Saved payment card",
      type: "Type",
      noCardDescription: "No payment method added",
      noCardFooter: "Add a card to enable subscription billing and automatic payments.",
      addCard: "Add card",
      changeCard: "Change card",
      removeCard: "Remove card",
      removeCardError: "Failed to remove card. Please try again.",
      removeCardModal: {
        title: "Remove payment card?",
        description: "This card will no longer be used for subscription billing.",
        confirm: "Remove card",
        cancel: "Cancel",
      },
      stripeNotReady: "Stripe is not ready. Please wait a moment and try again.",
      stripeSessionMissing: "Stripe session was not created. Please try again.",
      changeCardError: "Failed to start card update. Please try again.",
    },
    priorityCurrency: {
      title: "Priority currency",
      subtitle: "Choose the currency used by default for billing and invoices.",
      saveFailed: "Failed to update priority currency. Please try again.",
      currencyNames: {
        usd: "United States Dollar",
        eur: "Euro",
        gbp: "British Pound",
      },
      selected: "Selected",
    },
    billingContacts: {
      title: "Billing contacts",
      subtitle: "Contact details used on invoices and billing correspondence.",
      edit: "Edit",
      cancel: "Cancel",
      save: "Save",
      saving: "Saving…",
      saveFailed: "Failed to save billing contact. Please try again.",
      selectTaxNumberType: "Select type",
      selectCountry: "Select country",
      noCountries: "No countries found",
      companyName: "Company name",
      country: "Country",
      email: "Email",
      phone: "Phone",
      typeTaxNumber: "Tax number type",
      vatNumber: "Tax number",
      postcode: "Postcode",
      city: "City/Town",
      streetAddress: "Street address",
      address: "Address",
      fieldRequired: "This field is required",
      noTaxNumberTypes: "No matches",
    },
  },
  billingTable: {
    otherTabPlaceholder: "Table for this tab will be available later.",
  },
  banner: {
    fallback: "Something went wrong. Please try again.",
  },
};

export default productSettings;
